var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C9.33831 7.50437 8.70496 7.76916 8.23706 8.23706C7.76916 8.70496 7.50437 9.33831 7.5 10C7.5 11.3683 8.63167 12.5 10 12.5C11.3675 12.5 12.5 11.3683 12.5 10C12.5 8.6325 11.3675 7.5 10 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.16666C3.63917 4.16666 1.72751 9.68082 1.71001 9.73666L1.62167 9.99999L1.70917 10.2633C1.72751 10.3192 3.63917 15.8333 10 15.8333C16.3608 15.8333 18.2725 10.3192 18.29 10.2633L18.3783 9.99999L18.2908 9.73666C18.2725 9.68082 16.3608 4.16666 10 4.16666ZM10 14.1667C5.54084 14.1667 3.81334 10.9617 3.39501 9.99999C3.81501 9.03499 5.54334 5.83332 10 5.83332C14.4592 5.83332 16.1867 9.03832 16.605 9.99999C16.185 10.965 14.4567 14.1667 10 14.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.2284c09de9af49ec451efe4bb415b882.svg";
export { ForwardRef as ReactComponent };